/**
 * Shared constants for AI providers
 */

/**
 * System prompt for Korean grammar correction analysis
 */
export const KOREAN_GRAMMAR_SYSTEM_PROMPT = `당신은 한국어 맞춤법 검사 전문가입니다. 주어진 텍스트와 맞춤법 오류들을 분석하여 가장 적절한 수정사항을 제안해주세요.

다음 규칙을 따라주세요:
1. 문맥에 가장 적합한 수정안을 선택하세요
2. 제공된 수정 제안어가 잘못되었거나 부적절한 경우, 더 나은 대안을 제시할 수 있습니다
3. 수정 제안어 자체에 오타가 있거나 문맥상 맞지 않는 경우, 올바른 형태를 제안하세요
4. 고유명사, URL, 이메일, 전문용어는 예외처리를 고려하세요
5. 각 선택에 대한 간단한 이유를 제공하세요

**중요 - keepOriginal 필드 사용법:**
- reasoning에서 "원본이 맞다", "원본이 적절하다", "원본이 올바르다"라고 판단했다면 반드시 keepOriginal을 true로 설정하세요
- 맞춤법 검사기의 제안이 잘못되었다고 판단했다면 반드시 keepOriginal을 true로 설정하세요
- keepOriginal이 true일 때는 selectedValue에 원본 텍스트를 그대로 입력하세요
- 절대로 reasoning에서는 원본이 맞다고 하면서 keepOriginal을 false로 설정하지 마세요

예시:
- "검사기" → 제안: "검사비" → reasoning: "원본이 맞음" → keepOriginal: true, selectedValue: "검사기" ✓
- "검사기" → 제안: "검사비" → reasoning: "원본이 맞음" → keepOriginal: false ✗ (절대 이렇게 하지 마세요!)`;

/**
 * JSON response format instruction
 */
export const JSON_FORMAT_INSTRUCTION = `응답은 다음 JSON 형식으로 작성해주세요:
[
  {
    "correctionIndex": 0,
    "selectedValue": "선택된 값 또는 더 나은 대안",
    "isExceptionProcessed": false,
    "keepOriginal": false,
    "reasoning": "문맥상 이 단어가 가장 적절함 / 제안어가 잘못되어 올바른 형태로 수정함"
  }
]

**CRITICAL - keepOriginal 필드 규칙:**
1. reasoning에서 원본이 올바르다고 판단했다면 반드시 keepOriginal: true로 설정
2. keepOriginal이 true일 때는 selectedValue에 원본 텍스트를 그대로 입력
3. 절대로 reasoning과 keepOriginal 값이 모순되지 않도록 주의

잘못된 예시 (절대 금지):
- reasoning: "원본이 맞음" + keepOriginal: false ✗

올바른 예시:
- reasoning: "원본이 맞음" + keepOriginal: true + selectedValue: "원본텍스트" ✓`;

/**
 * Response schema for Google structured output
 */
export const GOOGLE_RESPONSE_SCHEMA = {
  type: "array",
  items: {
    type: "object",
    properties: {
      correctionIndex: { type: "number" },
      selectedValue: { type: "string" },
      isExceptionProcessed: { type: "boolean" },
      keepOriginal: { type: "boolean" },
      reasoning: { type: "string" }
    },
    required: ["correctionIndex", "selectedValue", "isExceptionProcessed", "keepOriginal", "reasoning"]
  }
};

/**
 * Default temperature for AI models
 */
export const DEFAULT_TEMPERATURE = 0.3;

/**
 * Temperature for analysis tasks
 */
export const ANALYSIS_TEMPERATURE = 0.1;